<article class="ci-panel w-full flex flex-column">
  <header class="w-full flex align-items-center justify-content-between">
    <!-- <section class="ci-panel__message ci-panel__marquee-container">
      <app-message [slug]="'home'"></app-message>
    </section> -->

    <section class="ci-panel__time">
      <app-weather-time [coords]="{ lat: -17.38810192916924, lon: -66.1557684813339}">
      </app-weather-time>
    </section>
  </header>

  <main class="w-full flex justify-content-center">
    <section class="ci-panel__brand-home flex justify-content-center align-items-start">
      <img src="https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fcocha-somos-innovacion-blanco.png?alt=media&token=32dd6e6f-d6a9-4e5b-bbf1-0ce2935ed5b2"
           alt="Somos innovación">
    </section>
  </main>
</article>